import Collapse from 'antd/lib/collapse';
import 'antd/lib/collapse/style/css';

export default Collapse;
